import { Skeleton } from '@/components/ui/feedback/status/skeleton';
import { cn } from '@/lib/ui/utils';
import type { CmsWorkspaceShellModel } from '../contracts/server-model';
import {
  WORKSPACE_PREVIEW_MASONRY_CLASS,
  WORKSPACE_PREVIEW_MASONRY_COLUMN_CLASS,
  WORKSPACE_PREVIEW_MASONRY_ITEM_CLASS,
  WORKSPACE_PREVIEW_MASONRY_SINGLE_CLASS,
  WORKSPACE_PREVIEW_MASONRY_WRAP_CLASS,
  distributeWorkspacePreviewImages,
  resolveWorkspacePreviewAspectRatio,
} from './workspace-preview-layout';
import { WORKSPACE_PREVIEW_INITIAL_COUNT } from './workspace-preview-media';

export function WorkspacePreviewSkeletonGrid({
  images,
  columnCount,
}: {
  images: CmsWorkspaceShellModel['hero']['previewImages'];
  columnCount: number;
}) {
  const columns = distributeWorkspacePreviewImages(images, columnCount);

  return (
    <div
      aria-hidden="true"
      className={cn('cms-masonry-image-grid', WORKSPACE_PREVIEW_MASONRY_CLASS)}
      data-column-count={columnCount}
      data-workspace-preview-skeleton=""
    >
      {columns.map((column, columnIndex) => (
        <div
          key={`workspace-preview-skeleton-column-${columnIndex}`}
          className={WORKSPACE_PREVIEW_MASONRY_COLUMN_CLASS}
          data-workspace-preview-column={columnIndex}
        >
          {column.map((image, index) => (
            <Skeleton
              key={`workspace-preview-skeleton-${index}-${image.src}`}
              className={cn(
                'cms-masonry-image-grid__item',
                WORKSPACE_PREVIEW_MASONRY_ITEM_CLASS
              )}
              data-cms-image-state="loading"
              data-cms-image-fallback="false"
              style={{
                aspectRatio: resolveWorkspacePreviewAspectRatio(image),
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export function WorkspacePreviewSkeleton({
  images,
}: {
  images: CmsWorkspaceShellModel['hero']['previewImages'];
}) {
  if (images.length === 0) {
    return null;
  }

  const columnCount = images.length === 1 ? 1 : 4;
  return (
    <div
      className={cn(
        WORKSPACE_PREVIEW_MASONRY_WRAP_CLASS,
        images.length === 1 && WORKSPACE_PREVIEW_MASONRY_SINGLE_CLASS
      )}
      data-workspace-preview-layout-skeleton=""
    >
      <WorkspacePreviewSkeletonGrid
        images={images.slice(0, WORKSPACE_PREVIEW_INITIAL_COUNT)}
        columnCount={columnCount}
      />
    </div>
  );
}
